var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isInMaintenanceMode)?_c('div',{staticClass:"promo-layout"},[_c('Header'),_vm._v(" "),_c('main',{attrs:{"id":"main","tabindex":"-1"}},[_c('nuxt')],1),_vm._v(" "),_c('PaywallOverlay')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }